// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__17Rzp","label":"Labeled_label__3BmPi","divider":"Labeled_divider__3vcVf"};